var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreaterThanDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "#00332D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2929 11.2929C14.6834 10.9024 15.3166 10.9024 15.7071 11.2929L20.7071 16.2929C21.0976 16.6834 21.0976 17.3166 20.7071 17.7071L15.7071 22.7071C15.3166 23.0976 14.6834 23.0976 14.2929 22.7071C13.9024 22.3166 13.9024 21.6834 14.2929 21.2929L18.5858 17L14.2929 12.7071C13.9024 12.3166 13.9024 11.6834 14.2929 11.2929Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThanDark);
export default __webpack_public_path__ + "static/media/greaterThanDark.5f21f61a9b43e9093675a7a43fcd9bde.svg";
export { ForwardRef as ReactComponent };